export default "https://cdn-static.gokick.com/assets/75ac565edfb9d82dbbe43c50f72b37b3535e18ca/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";